import React, { useState, useEffect, useContext } from "react";
import { Box, Typography, TextField, Select, MenuItem, Button, Checkbox, FormControlLabel, Divider, Slider } from "@mui/material";
import { AppContext } from "../context/AppContext";

const gemini_models = [
  "gemini-1.5-pro",
  "gemini-1.5-flash",
  "gemini-exp-1206",
  "gemini-exp-1121"
];

const deepseek_models = [
  "deepseek-reasoner",
];

const chatgpt_models = [
  "gpt-4o",
  "gpt-4o-mini",
  "gpt-4-turbo",
  "gpt-4",
  "gpt-3.5-turbo"
];

const claude_models = [
  "claude-3-opus-20240229"
];

const SettingsPanelActor = ({ name, api_provider, ai_agent, isMobile }) => {
  const {
    apiError, setAPIError,
    Actor_Model_apiProvider, setActor_Model_apiProvider,
    Critic_Model_apiProvider, setCritic_Model_apiProvider,
    Actor_Model_apiModel, setActor_Model_apiModel,
    Critic_Model_apiModel, setCritic_Model_apiModel,
    // Actor_Model_apikey, setActor_Model_apikey,
    // Critic_Model_apikey, setCritic_Model_apikey,
    temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
    temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider
  } = useContext(AppContext);

  // Initialize state with localStorage values or defaults
  const [temperature_val, setTemperature_val] = useState(() => {
  const stored = localStorage.getItem(`${name}-temperature_val`);
  if (stored) {
    const parsed = parseFloat(stored);
    // Ensure it's between 0 and 1
    return Math.min(1.0, Math.max(0.0, parsed || 0.3));
  }
  return 0.3;
});
  
  const [apiProvider, setApiProvider] = useState(localStorage.getItem(`${name}-apiProvider`) || (api_provider && api_provider[0]) || "Deepseek");
  
  const [apiModel, setApiModel] = useState(() => {
    const storedModel = localStorage.getItem(`${name}-apiModel`);
    const defaultModels = {
      // "Google Gemini": gemini_models[0],
      "Deepseek": deepseek_models[0],
      "OpenAI": chatgpt_models[0],
      "Anthropic": claude_models[0]
    };
    return storedModel || defaultModels[apiProvider] || deepseek_models[0];
  });
  
  const [apikey, setApikey] = useState( localStorage.getItem(`${name}-apikey`) || "" );

  // Function to handle temperature change
function temperature_function(event, newValue) {
  // Ensure the value is a number between 0 and 1
  const temp = typeof newValue === 'number' ? newValue : parseFloat(newValue) || 0.3;
  const clampedTemp = Math.min(1.0, Math.max(0.0, temp));
  
  setTemperature_val(clampedTemp);
  localStorage.setItem(`${name}-temperature_val`, clampedTemp.toString());
  
  // Update the context based on which model this is
  if (name === "Actor Model") {
    setTemperature_val_Actor_Model_apiProvider(clampedTemp);
  } else if (name === "Critic Model") {
    setTemperature_val_Critic_Model_apiProvider(clampedTemp);
  }
}

  // Handle API provider change
  const handleApiProviderChange = (e) => {
    const newProvider = e.target.value;
    setApiProvider(newProvider);
    setActor_Model_apiProvider(newProvider)
    localStorage.setItem(`${name}-apiProvider`, newProvider);
    
    // Update model to default for the selected provider
    const defaultModels = {
      // "Google Gemini": gemini_models[0],
      "Deepseek": deepseek_models[0],
      // "OpenAI": chatgpt_models[0],
      "Anthropic": claude_models[0]
    };
    
    const newModel = defaultModels[newProvider] || "";
    setApiModel(newModel);
    setActor_Model_apiModel(newModel)
    localStorage.setItem(`${name}-apiModel`, newModel);
    
    // Update the context based on which model this is
    if (name === "Actor Model") {
      setActor_Model_apiProvider(newProvider);
      setActor_Model_apiModel(newModel);
    } else if (name === "Critic Model") {
      setCritic_Model_apiProvider(newProvider);
      setCritic_Model_apiModel(newModel);
    }
  };

  // Handle API model change
  const handleApiModelChange = (e) => {
    const newModel = e.target.value;
    setApiModel(newModel);
    setActor_Model_apiModel(newModel)
    localStorage.setItem(`${name}-apiModel`, newModel);
    
    // Update the context based on which model this is
    if (name === "Actor Model") {
      setActor_Model_apiModel(newModel);
    } else if (name === "Critic Model") {
      setCritic_Model_apiModel(newModel);
    }
  };

  // Handle API key change
  const handleApiKeyChange = (e) => {
    const newKey = e.target.value;
    setApikey(newKey);
    // setActor_Model_apikey(newKey)
    localStorage.setItem(`${name}-apikey`, newKey);
    
    // Update the context based on which model this is
    if (name === "Actor Model") {
      // setActor_Model_apikey(newKey);
    } else if (name === "Critic Model") {
      // setCritic_Model_apikey(newKey);
    }
  };

  // Initialize default values in localStorage if not present
  useEffect(() => {
    if (!localStorage.getItem(`Actor Model-apiProvider`)) {
      localStorage.setItem(`Actor Model-apiProvider`, "Deepseek");
      setActor_Model_apiProvider("Deepseek");
    }
    if (localStorage.getItem(`Actor Model-apiProvider`)) {
      let Actor_Model_apiProvider = localStorage.getItem(`Actor Model-apiProvider`)
      setActor_Model_apiProvider(Actor_Model_apiProvider);
    }
    if (!localStorage.getItem(`Actor Model-apikey`)) {
      localStorage.setItem(`Actor Model-apikey`, "");
      // setActor_Model_apikey("");
    }
    if (localStorage.getItem(`Actor Model-apikey`)) {
      let Actor_Model_apikey = localStorage.getItem(`Actor Model-apikey`)
      // setActor_Model_apikey(Actor_Model_apikey);
    }
    if (!localStorage.getItem(`Actor Model-apiModel`)) {
      localStorage.setItem(`Actor Model-apiModel`, deepseek_models[0]);
      setActor_Model_apiModel(deepseek_models[0]);
    }
    if (localStorage.getItem(`Actor Model-apiModel`)) {
      let Actor_Model_apiModel = localStorage.getItem(`Actor Model-apiModel`)
      setActor_Model_apiModel(Actor_Model_apiModel);
    }
    if (!localStorage.getItem(`${name}-temperature_val`)) {
      localStorage.setItem(`${name}-temperature_val`, "0.3");
      setTemperature_val_Actor_Model_apiProvider(0.3);
    }
    if (localStorage.getItem(`${name}-temperature_val`)) {
      let Actor_Model_temperature_val = parseFloat(localStorage.getItem(`${name}-temperature_val`));
      setTemperature_val_Actor_Model_apiProvider(Actor_Model_temperature_val);
    }
    if (!localStorage.getItem(`Critic Model-apiProvider`)) {
      localStorage.setItem(`Critic Model-apiProvider`, "Deepseek");
      setCritic_Model_apiProvider("Deepseek");
    }
    if (localStorage.getItem(`Critic Model-apiProvider`)) {
      let Critic_Model_apiProvider = localStorage.getItem(`Critic Model-apiProvider`)
      setCritic_Model_apiProvider(Critic_Model_apiProvider);
    }
    if (!localStorage.getItem(`Critic Model-apikey`)) {
      localStorage.setItem(`Critic Model-apikey`, "");
      // setCritic_Model_apikey("");
    }
    if (localStorage.getItem(`Critic Model-apikey`)) {
      let Critic_Model_apikey = localStorage.getItem(`Critic Model-apikey`)
      // setCritic_Model_apikey(Critic_Model_apikey);
    }
    if (!localStorage.getItem(`Critic Model-apiModel`)) {
      localStorage.setItem(`Critic Model-apiModel`, deepseek_models[0]);
      setCritic_Model_apiModel(deepseek_models[0]);
    }
    if (localStorage.getItem(`Critic Model-apiModel`)) {
      let Critic_Model_apiModel = localStorage.getItem(`Critic Model-apiModel`)
      setCritic_Model_apiModel(Critic_Model_apiModel);
    }
    if (!localStorage.getItem(`${name}-temperature_val`)) {
      localStorage.setItem(`${name}-temperature_val`, "0.3");
      setTemperature_val_Critic_Model_apiProvider(0.3);
    }
    if (localStorage.getItem(`${name}-temperature_val`)) {
      let Critic_Model_temperature_val = localStorage.getItem(`${name}-temperature_val`)
      setTemperature_val_Critic_Model_apiProvider(Critic_Model_temperature_val);
    }
  }, []);

  return (
    <Box sx={{ 
      width: isMobile ? '100%' : 400, 
      padding: 0, 
      borderRadius: 2, 
      backgroundColor: "transparent", 
      color: "black", 
      display: "flex", 
      flexDirection: "column", 
      gap: isMobile ? 1 : 2 
    }}>
      <Box sx={{ lineHeight: "-15px", marginBottom: isMobile ? "-14px" : "-10px" }}>
        <Typography variant="body2" sx={{ 
          marginBottom: 1, 
          fontSize: isMobile ? 14 : 18, 
          fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`, 
          fontWeight: "750" 
        }}>{name}</Typography>
        <Typography variant="body2" sx={{ 
          marginBottom: "-2px", 
          fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`, 
          fontWeight: "750", 
          letterSpacing: "0px",
          fontSize: isMobile ? 12 : 14
        }}>API Provider</Typography>
        <Select 
          value={apiProvider} 
          onChange={handleApiProviderChange} 
          fullWidth 
          sx={{ 
            backgroundColor: "#808080d4", 
            color: "#fff", 
            borderColor: "transparent", 
            width: isMobile ? "90%" : "80%", 
            height: isMobile ? "30px" : "35px", 
            paddingTop: "5px",
            fontSize: isMobile ? 11 : 13
          }}
        >
          {api_provider?.map((provider) => (
            <MenuItem key={provider} value={provider}>{provider}</MenuItem>
          ))}
        </Select>
      </Box>
      {/* <Box sx={{ lineHeight: "-15px", marginBottom: "-10px" }}>
        <Typography variant="body2" sx={{ marginBottom: "-2px", fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`, fontWeight: "750", letterSpacing: "0px" }}>API Key</Typography>
        <TextField 
          type="text" 
          value={apikey} 
          onChange={handleApiKeyChange} 
          fullWidth 
          sx={{ "& .MuiInputBase-root": { backgroundColor: "#808080d4", color: "#fff", borderColor: "transparent", width: "98%", height: "35px", paddingTop: "5px" } }} 
        />
      </Box> */}
      {/* <div style={{ display: "flex", flexDirection: "column", justifyContent: "start", fontSize: "16px", color: "rgb(75, 85, 99)" }}>
        <div style={{ fontFamily: '"Arial"', marginTop: "-3px", fontSize: "13px", color: "rgb(75, 85, 99)" }}>This key is stored locally and only used to make API requests from this extension.</div>
      </div> */}
      <Box sx={{ lineHeight: "-15px", marginTop: isMobile ? "4px" : "6px", marginBottom: isMobile ? "-14px" : "-10px" }}>
        <Typography variant="body2" sx={{ 
          marginBottom: "-2px", 
          fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`, 
          fontWeight: "750", 
          letterSpacing: "0px",
          fontSize: isMobile ? 12 : 14
        }}>Model</Typography>
        <Select 
          value={apiModel} 
          onChange={handleApiModelChange} 
          fullWidth 
          sx={{ 
            backgroundColor: "#808080d4", 
            color: "#fff", 
            borderColor: "transparent", 
            width: isMobile ? "90%" : "80%", 
            height: isMobile ? "30px" : "35px", 
            paddingTop: "5px",
            fontSize: isMobile ? 11 : 13
          }}
        >
          {apiProvider === "Google Gemini" && gemini_models.map((model) => (
            <MenuItem key={model} value={model}>{model}</MenuItem>
          ))}
          {apiProvider === "Deepseek" && deepseek_models.map((model) => (
            <MenuItem key={model} value={model}>{model}</MenuItem>
          ))}
          {apiProvider === "OpenAI" && chatgpt_models.map((model) => (
            <MenuItem key={model} value={model}>{model}</MenuItem>
          ))}
          {apiProvider === "Anthropic" && claude_models.map((model) => (
            <MenuItem key={model} value={model}>{model}</MenuItem>
          ))}
        </Select>
        <div style={{ 
          fontFamily: '"Arial"', 
          marginTop: "1.2px", 
          fontSize: isMobile ? "11px" : "13px", 
          color: "rgb(75, 85, 99)" 
        }}>
          {apiProvider === "Google Gemini" && (
            <>
              <span style={{ fontWeight: "750", marginTop: "10px" }}>Max output: </span> 8,192 tokens
            </>
          )}
          {apiProvider === "Deepseek" && (
            <>
              <span style={{ fontWeight: "750", marginTop: "10px" }}>Max output: </span> 8,192 tokens
            </>
          )}
          {apiProvider === "OpenAI" && (
            <>
              <span style={{ fontWeight: "750", marginTop: "10px" }}>Max output: </span> 16,384 tokens
            </>
          )}
          {apiProvider === "Anthropic" && (
            <>
              <span style={{ fontWeight: "750", marginTop: "10px" }}>Max output: </span> 8,192 tokens
            </>
          )}
        </div>
        {!ai_agent && (
          <>
            <Typography variant="body2" sx={{ 
              marginTop: isMobile ? "4.5px" : "6.5px", 
              marginBottom: "-12px", 
              fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`, 
              fontWeight: "750", 
              letterSpacing: "0px",
              fontSize: isMobile ? 12 : 14
            }}>Temperature</Typography>
            <Slider 
              size="small" 
              value={temperature_val} 
              onChange={temperature_function} 
              valueLabelDisplay="auto" 
              aria-label="Temperature" 
              step={0.1} 
              min={0} 
              max={1.0} 
              sx={{ 
                color: "rgb(75, 85, 99)",
                width: isMobile ? "90%" : "100%",
                '& .MuiSlider-thumb': {
                  width: isMobile ? 16 : 20,
                  height: isMobile ? 16 : 20,
                },
                '& .MuiSlider-rail': {
                  height: isMobile ? 3 : 4,
                },
                '& .MuiSlider-track': {
                  height: isMobile ? 3 : 4,
                }
              }}
            />
          </>
        )}
      </Box>
      <Divider sx={{ 
        backgroundColor: "#333", 
        marginTop: ai_agent ? (isMobile ? "8px" : "10px") : "0px", 
        marginBottom: "0px", 
        color: "#333" 
      }} />
    </Box>
  );
};

export default SettingsPanelActor;